import { all } from 'redux-saga/effects';
import commonSlice from './common';
import authSlice from './auth';
import leadsSlice from './leads';
import creditReportSlice from './credit-report';
import hyperVergeSaga from './hyperverge';
import lender from './lenders';

export default function* root() {
  yield all([
    commonSlice(),
    authSlice(),
    creditReportSlice(),
    leadsSlice(),
    hyperVergeSaga(),
    lender(),
  ]);
}
